import type { ReactNode } from 'react'

// Two-column key/value row used by the detail pages. Long values wrap;
// the label uses `<dt>` / `<dd>` for screen-reader semantics so that
// detail panes read as definition lists.

interface DetailRowProps {
  label: ReactNode
  children: ReactNode
  className?: string
}

export function DetailRow({ label, children, className }: DetailRowProps) {
  return (
    <div
      className={[
        'grid grid-cols-1 gap-1 py-2 sm:grid-cols-[12rem_1fr] sm:gap-3',
        className,
      ].filter(Boolean).join(' ')}
    >
      <dt className="text-xs font-medium uppercase tracking-wide text-stone-500">
        {label}
      </dt>
      <dd className="text-sm text-stone-800">{children}</dd>
    </div>
  )
}
